import React from 'react';
import styled from "styled-components";
import { Link } from "gatsby";

const StyledlListItem = styled.li`
    display: block;
`
const StyledNavLink = styled(Link)`
    margin: 0 16px;
    color: ${props => (props.mobile ? 'var(--color-white)' : 'var(--color-black)')};
`

const NavItem = ({ link, clicked, mobile, children }) => {
    return (
        <StyledlListItem>
            <StyledNavLink to={link} onClick={clicked} mobile={mobile}>{children}</StyledNavLink>
        </StyledlListItem>
    )
};

export default NavItem;